<div class="ui-g m-b-0">
  <div class="ui-g-offset-3 ui-g-9">
    <h3 class="text-left m-t-0">{{ 'WS_DIRECTORY.PERSON_MODIFY.APPOINTMENTS.TITLE' | translate }}</h3>
  </div>
</div>

<div *ngFor="let appointment of appointments" class="ui-g">
  <div class="ui-g-3 text-right p-t-10">
    <b>{{appointment.standardTitle?.name}}</b>
    <i *ngIf="appointment.directoryTitle">({{ appointment.directoryTitle }})</i>
  </div>
  <div class="ui-g-9 p-t-10">
    <a
      [routerLink]="['/organizations', appointment.organization?.id, 'detail']">{{appointment.organization?.name || '???'}}</a>
    <span *ngIf="appointment.email?.length"> &bull; {{ appointment.email}}</span>
    <i class="fa fa-pen edit-appointment"
       (click)="modify(appointment)"
       pTooltip="{{ 'WS_DIRECTORY.PERSON_MODIFY.APPOINTMENTS.MODIFY_APPOINTMENT_TOOLTIP' | translate }}"
       tooltipPosition="bottom">
    </i>
    <i class="fa fa-trash delete-appointment"
       (click)="delete(appointment)"
       pTooltip="{{ 'WS_DIRECTORY.PERSON_MODIFY.APPOINTMENTS.REMOVE_APPOINTMENT_TOOLTIP' | translate }}">
    </i>
    <i *ngIf="appointment.orderNumber > 0" class="fa fa-angle-up move-appointment"
       (click)="moveAppointmentUp(appointment)"
       pTooltip="{{ 'WS_DIRECTORY.PERSON_MODIFY.APPOINTMENTS.CHANGE_APPOINTMENT_ORDER' | translate }}">
    </i>
    <i *ngIf="appointment.orderNumber < appointments?.length - 1" class="fa fa-angle-down move-appointment"
       (click)="moveAppointmentDown(appointment)"
       pTooltip="{{ 'WS_DIRECTORY.PERSON_MODIFY.APPOINTMENTS.CHANGE_APPOINTMENT_ORDER' | translate }}">
    </i>
  </div>
</div>

<div class="ui-g">
  <div class="ui-g-offset-3 ui-g-9">
    <button pButton
            type="button"
            label="{{ 'WS_DIRECTORY.PERSON_MODIFY.APPOINTMENTS.ADD_APPOINTMENT_BTN' | translate }}"
            (click)="addAppointment()"
            tooltipPosition="bottom">
    </button>
  </div>
</div>

<wsd-add-appointment-person
  [emails]="emails"
  (onSave)="onSave($event)">
</wsd-add-appointment-person>
